// React imports
import * as React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Project imports
import ExerciseContainer from './components/ExerciseContainer';

// Fontawesome imports
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
library.add(faSyncAlt);


class App extends React.Component<{}> {
  public render () {
    return (
      <Router>
        <Switch>
          <Route exact={true} path="/:projectId/:exerciseId" component={ExerciseContainer} />
          <Route render={() => <p>Page not Found</p>} />
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx